import type { DestroyRef, WritableSignal } from '@angular/core';
export function suggestionRowCount(columns: number, height: number): number {
    if (height >= 780) return columns === 2 ? 4 : 5;
    if (height >= 600) return columns === 2 ? 3 : 4;
    return columns === 2 ? 2 : 3;
}

export function responsiveSuggestionPageSize(
    width: number,
    height: number,
    appearance: 'outlined' | 'elevated',
    count: number
): number {
    const columns = width >= 672 ? 2 : 1;
    return appearance === 'elevated' && columns === 2 && height >= 780
        ? count
        : Math.max(2, columns * suggestionRowCount(columns, height));
}

export function observeResponsiveSuggestions(
    host: HTMLElement,
    context: {
        enabled: () => boolean;
        appearance: () => 'outlined' | 'elevated';
        count: () => number;
        pageSize: WritableSignal<number>;
        updateHeight: () => void;
        destroyRef: DestroyRef;
    }
) {
    const observer = new ResizeObserver(() => {
        if (context.enabled())
            context.pageSize.set(
                responsiveSuggestionPageSize(
                    host.clientWidth,
                    host.clientHeight,
                    context.appearance(),
                    context.count()
                )
            );
        context.updateHeight();
    });
    observer.observe(host);
    context.destroyRef.onDestroy(() => observer.disconnect());
}
